import { gql } from 'graphql-tag'
import { orderFieldsCMA } from './orderFieldsCMA'

export const GET_ORDER_BY_TRACKING_ID = gql`
  query getOrderByTrackingId($trackingId: String!, $includePickups: Boolean = false) {
    order: getOrderByTrackingId(trackingId: $trackingId, includePickups: $includePickups) {
      ...OrderFieldsCMA
    }
  }
  ${orderFieldsCMA}
`
